import { CreateBeneficiaryUseCase } from './CreateBeneficiaryUseCase'

export const createBeneficiaryUseCase = new CreateBeneficiaryUseCase({}).execute
